// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Envi","buttons":"styles_buttons__XH6l7"};